import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GLOBAL } from "./global";

@Injectable({
  providedIn: "root",
})
export class CitaService {
  public url: any;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  private createHeaders(token: any): HttpHeaders {
    return new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
      authorization: token,
    });
  }

  private createRequest(url: any, params: any, token: any): Observable<any> {
    return this._http
      .post(url, params, { headers: this.createHeaders(token) })
      .pipe(map((res) => res as any));
  }

  // Private helper method to handle POST requests
  /*private createRequest(url: any, body: any, token: any): Observable<any> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest'
  });
  return this._http.post(url, body, { headers: headers }).pipe(map(res => res.json()));
}
*/

  pifromUserLog(
    token: any,
    page: any,
    perPage: any,
    filtros: any[] = [],
    type: string = "",
    iduser: string = "",
    status = ""
  ) {
    let queryParams = `?page=${page}&perpage=${perPage}`;

    filtros.forEach((filtro) => {
      if (filtro && filtro.value) {
        queryParams += `&${filtro.key}=${encodeURIComponent(filtro.value)}`;
        if (filtro.key_type) {
          queryParams += `&${filtro.key_type}=${encodeURIComponent(
            filtro.type
          )}`;
        }
      }
    });

    return this.createRequest(
      this.url + `/cita/listPIFromUserLog${queryParams}`,
      `&iduser=${iduser}&name=${type}&` + `authorization=${token}`,
      token
    );
  }

  poPriority(
    token: any,
    page: any,
    perPage: any,
    listPo: any,
    iduser: string = "",
    type: string = ""
  ) {
    let queryParams = `?page=${page}&perpage=${perPage}`;

    return this.createRequest(
      this.url + `/cita/poPriority${queryParams}`,
      `&iduser=${iduser}&filter_po_priority=${listPo}&action=${type}&` +
        `authorization=${token}`,
      token
    );
  }

  getUsersRoles(token: any, role: any) {
    return this.createRequest(
      this.url + `/cita/users_roles`,
      `&role=${role}&` + `authorization=${token}`,
      token
    );
  }
  getDashboarData(
    token: any,
    type: any,
    filter?: any,
    page?: any,
    user_id?: any,
    all?: any,
    reserved?: any
  ): Observable<any> {
    // user_id = 37;
    const headers = this.createHeaders(token);
    const url = `${this.url}/api/widgets/${type}`;

    // Construir los parámetros condicionalmente
    let params: string[] = [];
    // params.push(`update=1`);
    if (filter) {
      params.push(`filter=${filter}`);
    }
    if (page) {
      params.push(`page=${page}`);
    }
    if (user_id) {
      params.push(`user_id=${user_id}`);
    }
    if (all) {
      params.push(`all=${all}`);
    }
    if (reserved) {
      params.push(`reserved=${reserved}`);
    }

    // Si hay parámetros, unirlos con "&"
    const queryString = params.length > 0 ? `?${params.join("&")}` : "";

    // Realizar la solicitud HTTP con los parámetros construidos
    return this._http.get(`${url}${queryString}`, { headers });
  }

  getDashboardNotes(token: any, userId?: any) {
    let urlWithParams = `${this.url}/note/list`;

    // Agrega ?user_id=... solo si está definido
    if (userId !== undefined && userId !== null && userId !== "") {
      urlWithParams += `?user_id=${userId}`;
    }

    return this.createRequest(urlWithParams, `authorization=${token}`, token);
  }
  listtoday(token: any) {
    return this.createRequest(
      this.url + "/cita/listtoday/PERSONAL",
      `authorization=${token}`,
      token
    );
  }

  createNote(token: any, note: any): Observable<any> {
    const json = JSON.stringify({ comment: note });
    const params = `json=${encodeURIComponent(
      json
    )}&authorization=${encodeURIComponent(token)}`;
    return this.createRequest(this.url + "/note/new", params, token);
  }

  editNote(token: any, note: any, id: any): Observable<any> {
    const json = JSON.stringify({ comment: note });
    const params = `json=${encodeURIComponent(
      json
    )}&authorization=${encodeURIComponent(token)}`;
    return this.createRequest(this.url + "/note/edit/" + id, params, token);
  }
  removeNote(token: any, note: any, id: any): Observable<any> {
    const json = JSON.stringify({ comment: note });
    const params = `json=${encodeURIComponent(
      json
    )}&authorization=${encodeURIComponent(token)}`;
    return this.createRequest(this.url + "/note/remove/" + id, params, token);
  }
  // getNote(token: any, note: any): Observable<any> {
  //   const json = JSON.stringify(note);
  //   const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
  //   const headers = new HttpHeaders({
  //     "Content-Type": "application/x-www-form-urlencoded",
  //     "X-Requested-With": "XMLHttpRequest",
  //   });
  //   return this._http
  //     .post<any>(`${this.url}/notes/new`, params, { headers })
  //     .pipe(map((res) => res));
  // }

  companiesLite(token: any) {
    return this.createRequest(
      this.url + "/company/alllistlite/thirdparty",
      `authorization=${token}`,
      token
    );
  }
  reminderStatus(token: any, reminderId: any) {
    return this.createRequest(
      this.url + "/reminder/setstatus/" + reminderId,
      `authorization=${token}`,
      token
    );
  }

  contactpartypickup(token: any, companyId: any) {
    return this.createRequest(
      this.url + "/contactpartypickup/listbycompany/" + companyId,
      `authorization=${token}`,
      token
    );
  }

  downloadReport(
    token: any,
    IdCita: any,
    download: boolean,
    seal?: any,
    plates?: any,
    nameTruck?: any,
    nameDriver?: any,
    nameMasterCompany?: any,
    rows?: any,
    conteo?: any,
    pickupdate?: any
  ) {
    let params;
    let headers;

    if (seal === null || seal === "") {
      headers = new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Requested-With": "XMLHttpRequest",
      });
      params = `id=${IdCita}&download=${download}&num=${rows}&seal=${seal}&conteo=${conteo}&pickupdate=${pickupdate}`;
    } else {
      headers = new HttpHeaders({
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      });
      params = {
        id: IdCita,
        download: download,
        num: rows,
        seal: seal,
        plates: plates,
        nameTruck: nameTruck,
        nameDriver: nameDriver,
        nameMasterCompany: nameMasterCompany,
        conteo: conteo,
        pickupdate: pickupdate,
      };
    }
    return this._http.post(
      "https://itaderp.com/luisha/report_pickup.php",
      seal === "" || seal === null ? params : JSON.stringify(params),
      {
        headers: headers,
        responseType: download ? ("blob" as "json") : "json",
      }
    );
  }

  updateNumberBol(token: any, bol_number: any, type: any, idcita: any) {
    return this.createRequest(
      this.url + "/cita/bol_number?page=1",
      `type=${type}&bolnumber=${bol_number}&idcita=${idcita}&authorization=${token}`,
      token
    );
  }

  updateThirdPartyTruck(token: any, rows: any, type: any, idcita: any) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    const body = {
      type: type,
      authorization: token,
      trucks: rows,
      idcita: idcita,
    };

    return this._http.post(this.url + "/cita/bol_number?page=1", body, {
      headers,
    });
  }

  showDataBol(token: any, type: any, idcita: any) {
    return this.createRequest(
      this.url + "/cita/bol_number?page=1",
      `type=${type}&idcita=${idcita}&authorization=${token}`,
      token
    );
  }

  updateBolRow(token: any, rows: any, type: any, idcita: any, PO: any) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    const body = {
      type: type,
      authorization: token,
      rowBol: rows,
      idcita: idcita,
      idpo: PO,
    };

    return this._http.post(this.url + "/cita/bol_number?page=1", body, {
      headers,
    });
  }

  upSealBol(token: any, type: any, idcita: any, seal: any) {
    return this.createRequest(
      this.url + "/cita/bol_number?page=1",
      `type=${type}&idcita=${idcita}&seal=${seal}&authorization=${token}`,
      token
    );
  }

  upDateBol(token: any, type: any, idcita: any, date: any) {
    return this.createRequest(
      this.url + "/cita/bol_number?page=1",
      `type=${type}&idcita=${idcita}&date=${date}&authorization=${token}`,
      token
    );
  }

  delRowBol(token: any, type: any, idcita: any, idbol: any) {
    return this.createRequest(
      this.url + "/cita/bol_number?page=1",
      `type=${type}&idcita=${idcita}&idbol=${idbol}&authorization=${token}`,
      token
    );
  }

  createBol(
    token: any,
    rows: any,
    type: any,
    idcita: any,
    PO: any,
    seal: any,
    date: any,
    pickupDate: any
  ) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    const body = {
      type: type,
      authorization: token,
      num: rows,
      idcita: idcita,
      idpo: PO,
      seal: seal,
      date: date,
      pickupDate: pickupDate,
    };

    return this._http.post(this.url + "/cita/bol_number?page=1", body, {
      headers,
    });
  }

  create(token: any, task: any) {
    task.environment = this.url;
    let json = encodeURIComponent(JSON.stringify(task));
    return this.createRequest(
      this.url + "/cita/new?page=1",
      `json=${json}&authorization=${token}`,
      token
    );
  }

  setContacts(token: any, task: any) {
    let json = encodeURIComponent(JSON.stringify(task));
    return this.createRequest(
      this.url + "/pickupcontact/newbulk?page=1",
      `json=${json}&authorization=${token}`,
      token
    );
  }

  updateContacts(token: any, pickup_id: any, task: any) {
    let json = encodeURIComponent(JSON.stringify(task));
    return this.createRequest(
      this.url + "/pickupcontact/updatepickup/" + pickup_id + "?page=1",
      `json=${json}&authorization=${token}`,
      token
    );
  }

  getCitasByDate(
    token: any,
    start: any,
    type: any,
    page: any = 1,
    user_id?: any
  ) {
    const baseUrl = `${this.url}/cita/listbydate/${type}?start=${start}&page=${page}`;
    const finalUrl = user_id ? `${baseUrl}&user_id=${user_id}` : baseUrl;

    return this.createRequest(finalUrl, `authorization=${token}`, token);
  }

  getListByPO(token: any, poId: any) {
    return this.createRequest(
      this.url + "/cita/listbypo/" + poId,
      `authorization=${token}`,
      token
    );
  }

  getListByPI(token: any, poId: any) {
    return this.createRequest(
      this.url + "/cita/processing/detailbypo/" + poId,
      `authorization=${token}`,
      token
    );
  }

  syncCompanies() {
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    this._http
      .get(
        "https://www.itaderp.com/backend/bot-extraer-pos/bot-extract-po.php?page=1",
        { headers: headers }
      )
      .subscribe();
    return this._http.get(
      "https://www.itaderp.com/backend/bot-extraer-pos/bot-extract-cv.php?page=1",
      { headers: headers }
    );
  }

  agendaNuevaCita(token: any, task: any) {
    let json = encodeURIComponent(JSON.stringify(task));
    return this.createRequest(
      this.url + "/cita/new/agenda?page=1",
      `json=${json}&authorization=${token}`,
      token
    );
  }

  getCitas(token: any, fecha: any, type: any = "PICKUP") {
    return this.createRequest(
      this.url + "/cita/list/" + type + "?page=1",
      `authorization=${token}&fecha=${fecha}`,
      token
    );
  }

  getVisitas(token: any, id: any, page: any = 1) {
    return this.createRequest(
      this.url + "/cita/listvisitas/" + id + "?page=" + page,
      `authorization=${token}`,
      token
    );
  }

  rsve(token: any, id: any) {
    return this.createRequest(
      this.url + "/cita/request-signature/" + id,
      `authorization=${token}`,
      token
    );
  }

  getCita(token: any, task: any, id: any) {
    let json = JSON.stringify(task);
    let params = `json=${json}&authorization=${token}`;
    return this.createRequest(
      this.url + "/cita/detail/" + id + "?page=1",
      params,
      token
    );
  }

  getpickupsqtybydate(
    token,
    page = null,
    perpage = null,
    data,
    filtros: any[] = []
  ): Observable<any> {
    let url = `${this.url}/cita/liststate?page=${page}&perpage=${perpage}`;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url += `&${filtro.key}=${filtro.value}`;

        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http
      .post<any>(url, params, { headers })
      .pipe(map((res) => res));
  }

  getpickupsqtybydatebytable(
    token,
    page = null,
    perpage = null,
    data,
    filtros: any[] = []
  ): Observable<any> {
    let url = `${this.url}/cita/liststatebytable?page=${page}&perpage=${perpage}`;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url += `&${filtro.key}=${filtro.value}`;

        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http
      .post<any>(url, params, { headers })
      .pipe(map((res) => res));
  }

  getpickupsbycity(
    token,
    page = null,
    perpage = null,
    data,
    filtros: any[] = []
  ): Observable<any> {
    let url = `${this.url}/cita/listcitybytable?page=${page}&perpage=${perpage}`;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url += `&${filtro.key}=${filtro.value}`;

        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http
      .post<any>(url, params, { headers })
      .pipe(map((res) => res));
  }

  getProcessingByPoNumber(token: any, id: any) {
    return this.createRequest(
      this.url + "/cita/getprocessingbyponumber/" + id + "?page=1",
      `authorization=${token}`,
      token
    );
  }

  update(token: any, task: any, id: any) {
    let json = encodeURIComponent(JSON.stringify(task));
    let params = `json=${json}&authorization=${token}`;
    return this.createRequest(
      this.url + "/cita/edit/" + id + "?page=1",
      params,
      token
    );
  }

  startCita(token: any, id: any) {
    return this.createRequest(
      this.url + "/cita/start/" + id + "?page=1",
      `authorization=${token}`,
      token
    );
  }

  deleteCita(token: any, id: any) {
    let task = {
      environment: this.url,
    };

    let json = encodeURIComponent(JSON.stringify(task));

    return this.createRequest(
      this.url + "/cita/remove/" + id + "?page=1",
      `json=${json}&authorization=${token}`,
      token
    );
  }

  removeSignatures(token: any, id: any) {
    let task = {
      environment: this.url,
    };
    let json = encodeURIComponent(JSON.stringify(task));
    return this.createRequest(
      this.url + "/cita/reset-signature/" + id + "?page=1",
      `json=${json}&authorization=${token}`,
      token
    );
  }

  getCitaByToken(token: any) {
    return this.createRequest(
      this.url + "/cita/getbytoken/" + token + "?page=1",
      undefined,
      token
    );
  }

  pickupSignature(token: any, data: any) {
    let json = encodeURIComponent(JSON.stringify(data));
    return this.createRequest(
      this.url + "/cita/pickupsignature/" + token + "?page=1",
      `json=${json}`,
      token
    );
  }
}
